<template>
    <v-layout row wrap>
        <v-dialog :value="!!ride_id" @input="ride_id = null" lazy>
            <ride-page v-if="ride_id" :ride_id="ride_id"/>
        </v-dialog>
        <v-flex xs6 class="px-1">
            <v-flex xs12>
                <v-data-table
                        :items="sortedActualLateness"
                        title="Actual Lateness"
                        :headers="headers.actual_lateness"
                        :pagination.sync="pagination.actual_lateness"
                >
                    <template v-slot:items="props">
                        <tr :style="(props.item.style || '')+';cursor:pointer;'"
                            @click="ride_id = props.item.ride_id">
                            <!--                        @mouseenter="highlightCaptain(props.item.captain_id)"-->
                            <!--                        @mouseleave="highlightCaptain(null)"-->
                            <td class="text-xs-center">{{ props.item.type }}</td>
                            <td class="text-xs-center">{{ props.item.captain_name }}</td>
                            <td class="text-xs-center">{{ props.item.passenger_name }}</td>
                            <td class="text-xs-center">{{ props.item.datetime }}</td>
                            <td class="text-xs-center" :style="props.item.style">
                                {{ props.item.lateness }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex xs12>
                <v-flex xs12>
                    <v-data-table
                            :items="sortedEndEstimatedLateness"
                            title="Estimated End Lateness"
                            :headers="headers.estimated_end_lateness"
                            :pagination.sync="pagination.estimated_end_lateness"
                    >
                        <template v-slot:items="props">
                            <tr :style="'cursor:pointer;'" @click="ride_id = props.item.booking.ride_id">
                                <!--                        @mouseenter="highlightCaptain(props.item.captain.captain_id)"-->
                                <!--                        @mouseleave="highlightCaptain(null)"-->
                                <td class="text-xs-center">{{ props.item.captain.captain_name }}</td>
                                <td class="text-xs-center">{{ props.item.booking.passenger.first_name }} {{
                                    props.item.booking.passenger.last_name }}
                                </td>
                                <td class="text-xs-center">{{
                                    moment(props.item.pick_up_time)
                                    .add(props.item.booking.estimated_time,'seconds').format("YYYY-MM-DD HH:mm") }}
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="props.item.lateness === -1">
                                        <div class="red--text">
                                            No Recent Captain Location
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ Math.floor(props.item.lateness/60) }} :
                                        {{Math.floor(props.item.lateness)%60}}
                                    </template>
                                </td>
                                <td class="text-xs-center">
                                    <template v-if="props.item.duration === -1">
                                        N/A
                                    </template>
                                    <template v-else>
                                        {{ Math.floor(props.item.duration/60) }} :
                                        {{Math.floor(props.item.duration)%60}}
                                    </template>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-flex xs6 class="px-1">
            <v-data-table
                    :items="sortedStartEstimatesLateness"
                    title="Estimated Lateness"
                    :headers="headers.estimated_start_lateness"
                    :pagination.sync="pagination.estimated_start_lateness"
            >
                <template v-slot:items="props">
                    <tr :style="'cursor:pointer;'" @click="ride_id = props.item.booking.ride_id">
                        <!--                        @mouseenter="highlightCaptain(props.item.captain.captain_id)"-->
                        <!--                        @mouseleave="highlightCaptain(null)"-->
                        <td class="text-xs-center">{{ props.item.captain.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.booking.passenger.first_name }} {{
                            props.item.booking.passenger.last_name }}
                        </td>
                        <td class="text-xs-center">{{ props.item.booking.datetime }}</td>
                        <td class="text-xs-center">
                            <template v-if="props.item.lateness === -1">
                                <div class="red--text">
                                    No Recent Captain Location
                                </div>
                            </template>
                            <template v-else>
                                {{ Math.floor(props.item.lateness/60) }} : {{props.item.lateness%60}}
                            </template>
                        </td>
                        <td class="text-xs-center">
                            <template v-if="props.item.duration === -1">
                                N/A
                            </template>
                            <template v-else>
                                {{ Math.floor(props.item.duration/60) }} :
                                {{Math.floor(props.item.duration)%60}}
                            </template>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>

</template>

<script>
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import RidePage from "@/views/RidePage";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import moment from "moment";

    export default {
        components: {RidePage},
        mixins: [socketEventsMixin, hasIntervalsMixin],
        title: "Lateness",
        name: "Lateness",
        events() {
            return {
                [this.api.SOCKET.EVENTS.LATE_BOOKING]: this.lateBooking,
                [this.api.SOCKET.EVENTS.LATE_CAPTAIN]: this.lateCaptain,
                'Timeline:update_booking_status': this.updateBookingStatus,
                [this.api.SOCKET.EVENTS.DELETE_BOOKING]: this.deleteBooking,
                [this.api.SOCKET.EVENTS.ESTIMATED_START_LATENESS]: this.updateStartEstimates,
                [this.api.SOCKET.EVENTS.ESTIMATED_END_LATENESS]: this.updateEndEstimates
            }
        },
        intervals() {
            return [
                [this.updateTime, 1000]
            ];
        },
        data() {
            return {
                passenger_late: [],
                captain_late: [],
                pagination: {
                    actual_lateness: {
                        descending: false,
                        sortBy: 'datetime',
                        rowsPerPage: -1
                    },
                    estimated_start_lateness: {
                        descending: false,
                        sortBy: "null",
                        rowsPerPage: -1
                    }
                },
                late_start_estimates: [],
                late_end_estimates: [],
                ride_id: null,

            };
        },
        computed: {
            sortedActualLateness() {
                return [
                    ...this.captain_late.map(i => ({...i, type: 'captain'})),
                    ...this.passenger_late.map(i => ({...i, type: 'passenger'})),
                ].sort((a, b) => moment(a.datetime).diff(b.datetime, 'minutes'))
            },
            sortedStartEstimatesLateness() {
                return [
                    ...this.late_start_estimates
                ].sort((a, b) => {
                    if (a.duration === -1)
                        return -1;
                    else if (b.duration === -1)
                        return 1;
                    else
                        return b.lateness - a.lateness;
                })
            },
            sortedEndEstimatedLateness() {
                return [
                    ...this.late_end_estimates
                ].sort((a, b) => {
                    if (a.duration === -1)
                        return -1;
                    else if (b.duration === -1)
                        return 1;
                    else
                        return b.lateness - a.lateness;
                });
            },
            headers() {
                return {
                    actual_lateness: [
                        {text: "Who's late", value: "type", align: "center"},
                        {text: "Captain Name", value: "captain_name", align: "center"},
                        {text: "Passenger Name", value: "passenger_name", align: "center"},
                        {text: "Waiting Since", value: "datetime", align: "center"},
                        {text: "Lateness", value: "lateness", align: "center"}
                    ],
                    estimated_start_lateness: [
                        {text: "Captain Name", value: "captain_name", align: "center"},
                        {text: "Passenger Name", value: "passenger_name", align: "center"},
                        {text: "Booking Datetime", value: "datetime", align: "center"},
                        {text: "Estimated Lateness", value: "lateness", align: "center"},
                        {text: "From Now", value: "from_now", align: "center"}
                    ],
                    estimated_end_lateness: [
                        {text: "Captain Name", value: "captain_name", align: "center"},
                        {text: "Passenger Name", value: "passenger_name", align: "center"},
                        {text: "Booking End", value: "datetime", align: "center"},
                        {text: "Estimated Lateness", value: "lateness", align: "center"},
                        {text: "From Now", value: "from_now", align: "center"}
                    ],

                };
            }
        },
        methods: {
            updateStartEstimates(late_start_estimates) {
                this.late_start_estimates = late_start_estimates;
                this.updateTime();
            },
            updateEndEstimates(late_end_estimated) {
                this.late_end_estimates = late_end_estimated;
                this.updateTime();
            },
            deleteBooking(bookingId) {
                this.captain_late = this.captain_late.filter(
                    ({booking_id}) => booking_id != bookingId
                );
                this.passenger_late = this.passenger_late.filter(
                    ({booking_id}) => booking_id != bookingId
                );
                this.late_start_estimates = this.late_start_estimates.filter(
                    ({booking: {id}}) => id != bookingId
                );
                this.late_end_estimates = this.late_end_estimates.filter(
                    ({booking: {id}}) => id != bookingId
                );
            },
            updateBookingStatus(bookingId, status) {
                if (status === "ARRIVED") {
                    this.captain_late = this.captain_late.filter(
                        ({booking_id}) => booking_id != bookingId
                    );
                    this.late_start_estimates = this.late_start_estimates.filter(
                        ({booking: {id}}) => bookingId != id
                    );
                } else if (status === "PICKED_UP") {
                    this.passenger_late = this.passenger_late.filter(
                        ({booking_id}) => booking_id != bookingId
                    );
                } else if (status === "DONE" || status === "PAID")
                    this.late_end_estimates = this.late_end_estimates.filter(
                        ({booking: {id}}) => bookingId != id
                    );

            },
            style({datetime, type}) {
                const diff = Math.min(moment().diff(datetime, 'minutes', true));
                const opacity = Math.floor(Math.min(diff / 5, 1) * 255);
                if (type === 'passenger')
                    return `color: rgb(255,183,26)`;
                else
                    return `color: rgb(255,20,20)`;

            },
            updateTime() {
                this.captain_late = this.captain_late.map(
                    i => {
                        const {datetime} = i;
                        let lateness = moment().diff(datetime, 'minutes', true);
                        lateness = `${Math.floor(lateness)} : ${Math.floor(60 * ((lateness - Math.floor(lateness))))}`;
                        const style = this.style(i);
                        return Object.assign({}, i, {lateness}, {style})
                    }
                );
                this.passenger_late = this.passenger_late.map(
                    i => {
                        const {datetime} = i;
                        let lateness = moment().diff(datetime, 'minutes', true);
                        lateness = `${Math.floor(lateness)} : ${Math.floor(60 * ((lateness - Math.floor(lateness))))}`;
                        const style = this.style(i);
                        return Object.assign({}, i, {lateness}, {style})
                    }
                );
                this.late_start_estimates = this.late_start_estimates.map(
                    i => Object.assign({}, i, {
                        lateness: i.duration === -1 ? -1 : moment().add(i.duration, 'seconds').diff(i.booking.datetime, 'seconds')
                    })
                );

                this.late_end_estimates = this.late_end_estimates.map(
                    i => Object.assign({}, i, {
                        lateness: Math.abs(
                            moment(i.pick_up_time).add(i.booking.estimated_time, 'seconds')
                            .diff(moment().add(i.duration, 'seconds'), 'seconds', true)
                        )
                    })
                );


            },
            lateBooking(passengers) {
                passengers.forEach(({captain_name, captain_id, passenger_name, datetime, booking_id, ride_id}) => {
                    this.captain_late = this.captain_late.filter(({booking_id: r}) => booking_id !== r);
                    this.passenger_late = this.passenger_late.filter(({booking_id: r}) => booking_id !== r);
                    let lateness = moment().diff(datetime, 'minutes', true);
                    lateness = `${Math.floor(lateness)} : ${Math.floor(60 * ((lateness - Math.floor(lateness))))}`;
                    this.passenger_late = [...this.passenger_late, {
                        captain_name,
                        passenger_name,
                        datetime,
                        booking_id,
                        ride_id,
                        captain_id,
                        lateness
                    }];
                });
            },
            lateCaptain(captains) {
                captains.forEach(({captain_name, passenger_name, captain_id, datetime, booking_id, ride_id}) => {
                    this.passenger_late = this.passenger_late.filter(({booking_id: r}) => booking_id !== r);
                    this.captain_late = this.captain_late.filter(({booking_id: r}) => booking_id !== r);
                    let lateness = moment().diff(datetime, 'minutes', true);
                    lateness = `${Math.floor(lateness)} : ${Math.floor(60 * ((lateness - Math.floor(lateness))))}`;
                    this.captain_late = [...this.captain_late, {
                        captain_name,
                        passenger_name,
                        datetime,
                        booking_id,
                        ride_id,
                        captain_id,
                        lateness
                    }];
                });
            }
        }
    }
</script>

<style scoped>

</style>